import React__default from 'react';
import { motion } from 'framer-motion';
import { MediaQuery, SliderCarousel } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';
import { isProductRecommendation } from './utils/guards.js';
import { isValidRecommendation } from './utils/is-valid-recommendation.js';
import { ListItemWrapper } from './components/ListItemWrapper.js';
import { ProductRecommendationContainer } from './components/ProductRecommendationContainer.js';
import { BannerRecommendationContainer } from './components/BannerRecommendationContainer.js';

const RecommendationListPage = ({ labels , recommendations , className  })=>{
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isPhone = MediaQuery.useIsPhone();
    const validRecommendations = recommendations.filter(isValidRecommendation);
    const renderRecommendation = (withListItem = false)=>(recommendation, index)=>{
            const isProductRec = isProductRecommendation(recommendation);
            const Wrapper = withListItem ? ListItemWrapper : React__default.Fragment;
            return /*#__PURE__*/ React__default.createElement(Wrapper, {
                key: isProductRec ? recommendation.sku : `${recommendation.position}-${recommendation.title}`
            }, isProductRec ? /*#__PURE__*/ React__default.createElement(ProductRecommendationContainer, {
                recommendation: recommendation,
                position: index + 1
            }) : /*#__PURE__*/ React__default.createElement(BannerRecommendationContainer, {
                recommendation: recommendation
            }));
        }
    ;
    if (!validRecommendations.length) return null;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "recommendation-list-page-layout--background"
    }, /*#__PURE__*/ React__default.createElement(Container, null, isBigScreen ? /*#__PURE__*/ React__default.createElement(motion.div, {
        style: {
            overflow: 'hidden'
        },
        variants: {
            start: {
                height: 0
            },
            end: {
                height: 'auto'
            }
        },
        transition: {
            type: 'tween'
        },
        initial: "start",
        animate: "end",
        className: `recommendation-list ${className}`
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement(motion.ul, {
        variants: {
            start: {
                opacity: 1
            },
            end: {
                opacity: 1
            }
        },
        transition: {
            delayChildren: 0.25,
            staggerChildren: 0.1
        },
        className: "recommendation-list__list"
    }, validRecommendations.map(renderRecommendation(true)))) : /*#__PURE__*/ React__default.createElement("div", {
        className: `recommendation-list ${className}`
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, validRecommendations.map(renderRecommendation())))));
};

export { RecommendationListPage };
//# sourceMappingURL=RecommendationListPage.js.map
